import React, {useState} from "react";
import {connect} from "react-redux";
import Popup from "../../components/Popup";
import {httpClient} from "../../funcs";
import {notifyAboutError, notifyUser} from "../../methods/notifyUser";
import {signOut} from "../../methods/loadSelf";
import VerificationCodeView from "../Auth/VerificationCodeView";
import {useRoute} from "react-router5";
import "pages/Styles/UIKit_v2.sass";

type Props = {
    $store: any,
    $commitToStore: Function,
    accountToDelete: any,
    onClose: Function,
    onSuccess: Function
}

let DeleteAccountPopup: any = function DeleteAccountPopup(props: Props) {
    const {$store, $commitToStore, accountToDelete, onClose, onSuccess} = props
    const $router = useRoute();
    
    const [step, setStep] = useState<'warning' | 'verification'>('warning')
    const [verificationCode, setVerificationCode] = useState('')
    const [codeChannel, setCodeChannel] = useState('tg-gateway')
    
    // Функция для запроса кода подтверждения
    async function handleRequestCode() {
        try {
            $commitToStore({
                loading: true
            })
            const response = await httpClient.post("/user/send-delete-account-code", {
                user_id: accountToDelete._id
            })
            
            // Обновляем канал на основе того, который реально использовался
            const usedChannel = response?.data?.used_channel || 'tg-gateway'
            setCodeChannel(usedChannel)
            
            setStep('verification')
            notifyUser(props, "Код подтверждения отправлен")
        } catch (error) {
            notifyAboutError(props, error)
        } finally {
            $commitToStore({
                loading: false
            })
        }
    }
    
    // Функция для отправки кода и удаления аккаунта
    async function handleDeleteAccount() {
        try {
            $commitToStore({
                loading: true
            })
            
            await httpClient.post("/user/delete-account", {
                user_id: accountToDelete._id,
                verification_code: verificationCode
            })
            
            notifyUser(props, "Аккаунт успешно удален")
            
            // Если мы удалили текущий аккаунт, выходим
            const isCurrentUser = accountToDelete._id === $store.userSession?._id;
            
            // Закрываем попап перед выходом из системы
            onClose();
            
            console.log("isCurrentUser", isCurrentUser)
            if (isCurrentUser) {
                // Выполняем выход с задержкой, чтобы попап успел закрыться
                signOut(props);
                setTimeout(() => {
                    // Перенаправляем на главную страницу
                    $router.router.navigate('main');
                }, 300);
            } else {
                // Иначе просто обновляем список пользователей
                onSuccess();
            }
        } catch (error) {
            notifyAboutError(props, error);
        } finally {
            $commitToStore({
                loading: false
            });
        }
    }
    
    return (
        <Popup onClose={() => onClose()}>
            <>
                <div className="popup-title">Удаление аккаунта</div>
                
                {step === 'warning' ? (
                    <>
                        <div className="Subtitle_18" style={{marginTop: "10px", marginBottom: "16px"}}>
                            Внимание! Это действие необратимо.
                        </div>
                        
                        <div className="Body_16_v2" style={{marginBottom: "16px"}}>
                            При удалении аккаунта из системы будут удалены:
                        </div>
                        
                        <ul style={{
                            listStyle: "none",
                            padding: 0,
                            margin: "0 0 16px 0"
                        }}>
                            <li style={{
                                display: "flex",
                                alignItems: "flex-start",
                                marginBottom: "12px",
                                paddingLeft: "24px",
                                position: "relative"
                            }}>
                                <span style={{
                                    position: "absolute",
                                    left: 0,
                                    top: "4px",
                                    width: "6px",
                                    height: "6px",
                                    borderRadius: "50%",
                                    backgroundColor: "#6B7280"
                                }}></span>
                                <span className="Body_16_v2_secondary">
                                    Все персональные данные аккаунта
                                </span>
                            </li>
                            <li style={{
                                display: "flex",
                                alignItems: "flex-start",
                                marginBottom: "12px",
                                paddingLeft: "24px",
                                position: "relative"
                            }}>
                                <span style={{
                                    position: "absolute",
                                    left: 0,
                                    top: "4px",
                                    width: "6px",
                                    height: "6px",
                                    borderRadius: "50%",
                                    backgroundColor: "#6B7280"
                                }}></span>
                                <span className="Body_16_v2_secondary">
                                    Содержание всех подписанных вами договоров
                                </span>
                            </li>
                        </ul>
                        
                        <div className="Body_16_v2" style={{
                            marginBottom: "20px",
                            padding: "16px",
                            backgroundColor: "#EEF1F7",
                            borderRadius: "12px"
                        }}>
                            После удаления аккаунта вам будет выслан акт о прекращении обработки персональных данных на указанный email.
                        </div>
                        
                        <button 
                            className="action-button primary"
                            disabled={$store.loading}
                            onClick={handleRequestCode}
                        >
                            <span className="button-text">Запросить код подтверждения</span>
                        </button>
                    </>
                ) : (
                    <>
                        <div className="Subtitle_18" style={{marginTop: "10px", marginBottom: "16px"}}>
                            Подтверждение удаления
                        </div>
                        
                        <div className="Body_16_v2_secondary" style={{marginBottom: "20px"}}>
                            Для подтверждения удаления введите код подтверждения, отправленный на номер {accountToDelete.phone_number}
                        </div>
                        
                        <VerificationCodeView
                            verification_code={verificationCode}
                            code_channel={codeChannel}
                            phone_number={accountToDelete.phone_number}
                            disabled_code_channels={['tg', 'call']}
                            updateVerificationCode={setVerificationCode}
                            updateCodeChannel={setCodeChannel}
                            finish={handleDeleteAccount}
                            back={() => setStep('warning')}
                            purpose="delete_account"
                            purpose_meta={{
                                user_id: accountToDelete._id,
                                is_current_user: accountToDelete._id === $store.userSession?._id
                            }}
                            $store={$store}
                        />
                    </>
                )}
            </>
        </Popup>
    )
}

DeleteAccountPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(DeleteAccountPopup)

export default DeleteAccountPopup
